import { SplineItems } from '@/engine/app/interfaces.ts';
import { AreaValueType, type ISplineItemConfig } from './interface.ts';

import type { CSSProperties } from 'react';
import type { Theme } from '@mui/material/styles';

const commonSplineItemConfigCollection: Array<ISplineItemConfig> = [
  getSplineItemConfig(SplineItems.Perimeter, AreaValueType.perimeter, 'Perimeter'),
  getSplineItemConfig(SplineItems.Area, AreaValueType.area, 'Area'),
  getSplineItemConfig(SplineItems.MaxDiameter, AreaValueType.dMax, 'Max diameter'),
  getSplineItemConfig(SplineItems.MinDiameter, AreaValueType.dMin, 'Min diameter'),
  getSplineItemConfig(SplineItems.PdDiameter, AreaValueType.pdDiameter, 'Perimeter-derived diameter')
];

export const apSlSplineItemConfigCollection: Array<ISplineItemConfig> = [
  getSplineItemConfig(SplineItems.ApDistance, AreaValueType.dY, 'AP distance'),
  getSplineItemConfig(SplineItems.SlDistance, AreaValueType.dX, 'SL distance')
];

export const config: Array<ISplineItemConfig> = [
  ...commonSplineItemConfigCollection,
  ...apSlSplineItemConfigCollection
];

function getSplineItemConfig(splineItem: SplineItems, valueKey: AreaValueType, label: string): ISplineItemConfig {
  return {
    label: label,
    splineItem: splineItem,
    labelKey: splineItem.toLowerCase() + '-label',
    measurementKey: splineItem.toLowerCase() + '-measurement',
    valueKey: valueKey,
    unitOfMeasurement: splineItem === SplineItems.Area ? 'mm²' : 'mm'
  };
}

export function getSplineItemStyleConfig(splineItem: SplineItems, theme: Theme): CSSProperties | undefined {
  const { apDistance, slDistance } = theme.customPalette.objects;
  switch (splineItem) {
    case 'ApDistance':
      return { color: apDistance, fontWeight: 'bold' };
    case 'SlDistance':
      return { color: slDistance, fontWeight: 'bold' };
    default:
      return undefined;
  }
}

export enum WamDescriptor {
  Points = 0,
  ApSlDistanceOrientation = 1
}
